export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "new_package_group": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuevo pallet"])}
        }
      }
    }
  })
}